<template>
  <div class="wzPage--winners">
    <div class="topCupBox">
      <div v-if="cupInfo" class="cupInfo">
        <div class="cupInfo__logo">
          <img :src="cupInfo.cupLogo" />
        </div>
        <dl class="cupInfo__txt">
          <dt>{{cupInfo.cupName}}</dt>
          <dd>开始: <span class="cupInfo__time">{{cupInfo.startTime|time2text('YYYY年M月D日hh点mm分')}}</span></dd>
          <dd>结束: <span class="cupInfo__time">{{cupInfo.endTime|time2text('YYYY年M月D日hh点mm分')}}</span></dd>
        </dl>
      </div>
    </div>
    
    <div class="sect-wrap" v-if="canShowRes">
      <k-hr size="30" skin="none" />
      <div class="sect__bd">
        <div class="mod">
          <div class="mod__bd" v-if="myResult">
            <div class="myResult" v-if="myResult.lucky">
              <div class="myResult__h1">恭喜您中了幸运名次奖!</div>
              <div class="myResult__h3">收益排名：第{{myResult.rank}}名</div>
              <div class="myResult__desc">奖品：价值660元的2个月斗K权限</div>
            </div>
            <div class="myResult" v-else-if="myResult.random">
              <div class="myResult__h1">恭喜您中了随机锦鲤奖!</div>
              <div class="myResult__h3">随机序号：{{myResult.randomOid}}</div>
              <div class="myResult__desc">奖品：2个斗K擂台</div>
            </div>
            <div class="myResult" v-else >
              <div class="myResult__h1">很遗憾，您未中奖!</div>
              <div class="myResult__h3">祝您在其他擂台中锦鲤附身</div>
              <div class="myResult__desc">另外，此次王粉节还有幸运大抽奖活动，重要的是<br>100%中奖！<a :href="urlLottery">马上抽奖</a></div>
            </div>
          </div>
          <k-loading v-else></k-loading>
        </div>
      </div>
    </div>
    
    <div class="sect-wrap">
      <div class="sect__hd">
        <h1 class="sect_hd__h1">【{{cupName}}】幸运奖</h1>
      </div>
      <div class="sect__bd">
        <div class="mod">
          <div class="mod_bd" v-if="!canShowRes">
            <k-no-data>{{showTime|time2text}} 公布获奖名单</k-no-data>
          </div>
          <div class="mod_bd" v-else-if="luckyWinners">
                <div class="mod__desc" v-if="luckyWinners.length > 0">
                    <dl>
                        <dd>好运来，祝你好运来！<br>恭喜以下{{luckyWinners.length}}位嘉宾获得【{{cupName}}】幸运名次奖：</dd>
                    </dl>
                </div>
                <div v-if="luckyWinners.length > 0" class="k-table k-table--rank skin-match">
                    <table cellspacing="0">
                        <tr>
                            <th class="fst">排名</th>
                            <th class="ta-left">账号信息</th>
                            <th class="lst">收益率</th>
                        </tr>
                        <template v-for="item in luckyWinners">
                            <tr v-if="item" :key="item.uid" :class="{active: myUid === item.uid}">
                            <td>第{{item.preRank}}名</td>
                            <td class="ta-left"><k-user class="k-user--m" :nick="item.nick" :logo="item.logoSrc" /></td>
                            <td class="rate"><k-rate :value="item.preRate" :skin="item.preRate - 1" /><small>({{item.totalGameNum}}局)</small></td>
                            </tr>
                        </template>
                    </table>
                </div>
                <k-no-data v-else>暂无获奖名单</k-no-data>
            </div>
            <div class="mod_bd" v-else><k-loading /></div>
        </div>
        <div class="sect_bd__desc">
            <dl>
                <dt>活动规则</dt>
                <dd>【斗K大联欢】活动期间，每个擂台中，排名第52名、66名、88名、166 名、188名、520名、888名、1888名、2888 名、5200 名的用户获得幸运名次奖</dd>
                <dt>奖品</dt>
                <dd>价值660元的2个月斗K权限</dd>
            </dl>
        </div>        
      </div>
    </div>
    
   <div class="sect-wrap">
     
      <div class="sect__hd">
        <h1 class="sect_hd__h1">【{{cupName}}】随机锦鲤奖</h1>
      </div>
      <div class="sect_bd">
          <div class="mod">
            <div class="mod_hd" v-if="canShowRes">
                <div class="mod__desc" v-if="randomWinners && randomWinners.length > 0">锦鲤附我身！<br>恭喜以下{{randomWinners.length}}位嘉宾获得【{{cupName}}】随机锦鲤奖：</div>
            </div>
            <div class="mod_bd" v-if="!canShowRes">
              <k-no-data>{{showTime|time2text}} 公布获奖名单</k-no-data>
            </div>
            <div class="mod_bd" v-else-if="randomWinners">
                  <div v-if="randomWinners.length > 0" class="k-table k-table--rank skin-match">
                      <table cellspacing="0">
                          <tr>
                              <th class="fst">序号</th>
                              <th class="ta-left">账号信息</th>
                              <th class="lst">收益率</th>
                          </tr>
                          <template v-for="(item,index) in randomWinners">
                              <tr v-if="item" :key="item.uid" :class="{active: myUid === item.uid}">
                              <td class="oid">{{index + 1}}</td>
                              <td class="ta-left"><k-user class="k-user--m" :nick="item.nick" :logo="item.logoSrc" /></td>
                              <td class="rate"><k-rate :value="item.preRate" :skin="item.preRate - 1" /><small>({{item.totalGameNum}}局)</small></td>
                              </tr>
                          </template>
                      </table>       
                  </div>
                  <k-no-data v-else>
                    <div v-if="!canShowRes">{{showTime|time2text}} 公布获奖名单</div>
                    <div v-else>暂无获奖名单</div>
                  </k-no-data>
              </div>
              <div v-else class="mod_bd"><k-loading /></div>
          </div>
          <div class="sect_bd__desc">
            <dl>
                <dt>活动规则</dt>
                <dd>系统随机抽取200名用户进行派奖</dd>
                <dt>奖品</dt>
                <dd>2个斗K擂台；</dd>
            </dl>
          </div>
          <k-hr size="50" skin="none"></k-hr>
      </div>
   </div>
    <a href="/520/2019/" class="icon-wfj"></a>
  </div>
</template>

<script>
  import { mapActions, mapState, mapGetters } from 'vuex'
  export default {
    props: ['cId'],
    computed: {
      ...mapGetters(['myUid']),
      ...mapState('config', ['matchConfigs', 'awardMap']),
      ...mapState('winners', ['luckyWinners', 'randomWinners']),
      ...mapGetters('winners', ['myResult']),
      ...mapGetters(['beginTime']),
      ...mapGetters('config', ['matchOf', 'cupOf']),
      ...mapGetters('timer', ['isAfter']),
      config() {
        return this.matchOf(this.cId)
      },
      cupInfo() {
        return this.cupOf(this.cId)
      },
      cupName() {
        const {cupInfo} = this
        return cupInfo ? cupInfo.cupName : ''
      },
      showTime() {
        const {config} = this
        return config && config.preRes > 0 ? +config.preRes : 0
      },
      canShowRes() {
        const {showTime} = this
        return showTime ? this.isAfter(showTime) : false
      },
      urlLottery() {
        const {awardMap} = this
        return awardMap && awardMap.lotteryMap ? awardMap.lotteryMap.url : ''
      }
    },
    methods: {
      ...mapActions('winners', ['loadLuckyWinners', 'loadRandomWinners']),
      async fetch() {
        const {config, canShowRes} = this
        if(config) {
          const query = { cId: config.id }
          await this.loadLuckyWinners(query)
          await this.loadRandomWinners(query)
        }
      }
    },
    watch: {
      matchConfigs: 'fetch',
      canShowRes: 'fetch'
    },
    created() {
      this.fetch()
    }
  }
</script>
